import { render, staticRenderFns } from "./Clinics.vue?vue&type=template&id=12736736&scoped=true"
import script from "./Clinics.vue?vue&type=script&lang=js"
export * from "./Clinics.vue?vue&type=script&lang=js"
import style0 from "./Clinics.vue?vue&type=style&index=0&id=12736736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12736736",
  null
  
)

export default component.exports